<as-split direction="horizontal" class="h-full" [useTransition]="true" [gutterSize]="5">
  <as-split-area [size]="activeTablePath ? 50 : 100">
    <y42-list-view
      y42FeatureListView
      [id]="$any('select-data-source-table')"
      [canAdd]="false"
      [canEdit]="false"
      [hasPadding]="hasPadding"
      [hideQuickFilters]="true"
      [name]="hideListViewTitle ? '' : 'Select data source'"
      [searchLabel]="'Search for data source'"
      [searchPlaceholder]="'Search for name, tables, ...'"
      [searchFieldAppearance]="searchFieldAppearance"
      [searchFieldClasses]="'grid-row-search px-3'"
      [gridOptions]="gridOptions"
      [columnDefs]="columnDefs"
      [frameworkComponents]="frameworkComponents"
      (cellClicked)="cellClicked($event)"
      (gridRowClicked)="selectionDisabled && rowClicked($event)"
      (gridSelectionChanged)="!selectionDisabled && selectDatasource($event)"
      (gridReady)="gridReady($event)"
    ></y42-list-view>
  </as-split-area>

  <as-split-area [size]="50" *ngIf="activeTablePath">
    <y42-table-viewer [tableId]="activeTablePath"></y42-table-viewer>
  </as-split-area>
</as-split>
